<template>
  <section class="asc-user-profile--information">
    <asc-text-field-input
      v-model="fullName"
      class="asc-user-profile--information__item"
      readonly
      hide-details
      label="Name"
      :no-spacing="false"
    />
    <asc-text-field-input
      v-model="username"
      class="asc-user-profile--information__item"
      readonly
      hide-details
      label="Username"
      :no-spacing="false"
    />
    <asc-text-field-input
      v-model="email"
      class="asc-user-profile--information__item"
      readonly
      hide-details
      label="Email"
      :no-spacing="false"
    />
  </section>
</template>

<script>
import AscTextFieldInput from '@/components/atoms/AscTextFieldInput'

export default {
  name: 'AscUserProfileInfo',

  components: {
    AscTextFieldInput,
  },

  props: {
    userProfile: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    email() {
      return this.userProfile.userEmail || '--'
    },
    fullName() {
      return this.userProfile.firstName && this.userProfile.lastName
        ? `${this.userProfile.firstName} ${this.userProfile.lastName}`
        : '--'
    },
    username() {
      return this.userProfile.username || '--'
    },
  },
}
</script>

<style lang="scss">
.asc-user-profile--information {
  position: relative;

  &__item {
    margin-bottom: 21px;
  }
}
</style>
